// extracted by mini-css-extract-plugin
export default {"wrapper":"PersonalProfile_wrapper__7r96z","link":"PersonalProfile_link__DShkX"};